import axios from "axios";
import $ from 'jquery';

const http = axios.create({
    baseURL: global.API_URI || "",
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
})

http.interceptors.response.use(function (resp) {
    return Promise.resolve(resp.data);
});

export default {
    confirm({phone, rules = '', id}) {
        return http.post("/coupon/confirm", {
            phone,
            rules,
            activity_retail_id: id
        });
    }
}